import { render, staticRenderFns } from "./classTeacherReamark.vue?vue&type=template&id=50bef64f"
import script from "./classTeacherReamark.vue?vue&type=script&lang=js"
export * from "./classTeacherReamark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports